<template>
    <div>
        <section class="modal-card-body">
            <div>
                {{ trans.modal_body_user_message }}
                <label class="checkbox mt-1">
                    <input type="checkbox" :disabled="isFormDisabled" v-model="isImportant">
                    {{ trans.modal_body_user_message_important_parameter }}
                </label>
                <label class="checkbox mt-1">
                    <input type="checkbox" :disabled="isFormDisabled" v-model="isBx24UsersChosen" :checked="isBx24UsersChosen">
                    {{ trans.modal_body_user_message_choose_users_parameter }}<i>{{ selectedBx24Users }}</i>
                </label>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button
                class="button is-info"
                :class="{ 'is-loading': isLoading }"
                :disabled="isFormDisabled"
                @click="publishArticle"
            >
                {{ trans.button_publish }}
            </button>
            <button
                class="button"
                :disabled="isFormDisabled"
                @click="closeModal"
            >
                {{ trans.button_cancel }}
            </button>
        </footer>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "PublishArticleSendBody",
    data() {
        return {
            isImportant: false,
            isBx24UsersChosen: false,
            isUserTryToChooseBx24Users: false,
        };
    },
    computed: {
        ...mapGetters('bx24ActivityStreamManager', [
            'trans',
            'isLoading',
            'bxResponseUserName',
            'bxResponseUserId',
        ]),
        selectedBx24Users() {
            if (this.isBx24UsersChosen) {
                return ': ' + this.bxResponseUserName.join(', ') + '.';
            }
        },
        isFormDisabled() {
            return this.isLoading || this.isUserTryToChooseBx24Users;
        },
    },
    methods: {
        ...mapActions('bx24ActivityStreamManager', {
            hideModal: 'hidePublishArticleMainModalModal',
        }),
        ...mapActions('bx24ActivityStreamManager', [
            'publishArticle',
            'addActivityStreamParameters',
            'setAtSelectUsersBxResponse',
            'unsetAtSelectUsersBxResponse',
            'removeActivityStreamParameters',
        ]),
        closeModal() {
            this.hideModal();
        },
        onUsersSelected(users) {
            if (JSON.parse(JSON.stringify(users)).length === 0) {
                this.isBx24UsersChosen = false;
            } else {
                this.setAtSelectUsersBxResponse(users);
                this.addActivityStreamParameters({DEST: this.bxResponseUserId});
                this.isUserTryToChooseBx24Users = false;
            }
        },
    },
    watch: {
        isImportant(newValue, oldValue) {
            newValue
                ? this.addActivityStreamParameters({IMPORTANT: 'Y'})
                : this.removeActivityStreamParameters('IMPORTANT');
        },
        isBx24UsersChosen(newValue, oldValue) {
            if (newValue) {
                this.unsetAtSelectUsersBxResponse();
                BX24.selectUsers(this.onUsersSelected);
                this.isUserTryToChooseBx24Users = true;
            } else {
                this.removeActivityStreamParameters('DEST');
                this.unsetAtSelectUsersBxResponse();
                this.isUserTryToChooseBx24Users = false;
            }
        },
    },
}
</script>

<style scoped>
    .bulma .modal-card-body {
        overflow: inherit;
    }
    .checkbox {
        display: block;
    }
</style>
